import { ofType } from 'redux-observable';
import { switchMap, map, catchError } from 'rxjs/operators';
import { from, of } from 'rxjs';
import { FETCH_RECURRENCES_REQUEST, EPIC_ERROR } from 'Constants/redux';
import service from 'Api/service';
import { receiveRecurrences } from 'Actions';

const requestParameters = (action) => {
  const { payload, per, page, query } = action;
  return payload?.all ? payload : { per, page, query };
};

const FetchRecurrencesEpic = (action$) =>
  action$.pipe(
    ofType(FETCH_RECURRENCES_REQUEST),
    switchMap((action) =>
      from(
        service.get(
          `${import.meta.env.VITE_API_DOMAIN}/api/recurrences`,
          requestParameters(action)
        )
      ).pipe(
        map((response) => receiveRecurrences(response)),
        catchError((error) => {
          console.error('FetchRecurrencesEpic error', error);
          return of({ type: EPIC_ERROR });
        })
      )
    )
  );

export default FetchRecurrencesEpic;
